import { render, staticRenderFns } from "./ImportWhOrdersModal.vue?vue&type=template&id=231c2c2d&scoped=true&"
import script from "./ImportWhOrdersModal.vue?vue&type=script&lang=js&"
export * from "./ImportWhOrdersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231c2c2d",
  null
  
)

export default component.exports